import { Injectable } from '@angular/core';
import { CountryService } from './utils/country.service';

// Mapa de país → idioma de Google Translate
const COUNTRY_LANG_MAP: Record<string, string> = {
  // Inglés
  US: 'en', GB: 'en', AU: 'en', CA: 'en', NZ: 'en', IE: 'en', ZA: 'en',
  // Portugués
  BR: 'pt', PT: 'pt', AO: 'pt', MZ: 'pt',
  // Francés
  FR: 'fr', BE: 'fr', CH: 'fr', LU: 'fr', SN: 'fr', CI: 'fr', CM: 'fr',
  // Italiano
  IT: 'it',
  // Alemán
  DE: 'de', AT: 'de',
  // Holandés
  NL: 'nl',
  // Ruso
  RU: 'ru', UA: 'ru', BY: 'ru', KZ: 'ru',
  // Chino
  CN: 'zh-CN', TW: 'zh-CN',
  // Japonés
  JP: 'ja',
  // Árabe
  SA: 'ar', AE: 'ar', EG: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar', LY: 'ar',
  QA: 'ar', KW: 'ar', BH: 'ar', JO: 'ar', LB: 'ar', IQ: 'ar', YE: 'ar',
  // Países hispanohablantes → NO traducir (español es el idioma base)
  ES: 'es', MX: 'es', CO: 'es', AR: 'es', CL: 'es', PE: 'es', VE: 'es',
  EC: 'es', BO: 'es', PY: 'es', UY: 'es', CR: 'es', PA: 'es', HN: 'es',
  SV: 'es', GT: 'es', NI: 'es', DO: 'es', CU: 'es', PR: 'es',
};

@Injectable({
  providedIn: 'root',
})
export class AutoTranslateService {
  private translated = false;

  constructor(private countryService: CountryService) {}

  /**
   * Llama esto una sola vez desde el AppComponent (ngOnInit).
   * Detecta el país por IP y traduce la página automáticamente si corresponde.
   * Reutiliza el país que ya pidió el arranque (CountryService comparte la petición),
   * así que no genera una segunda llamada a /ip/country.
   */
  init(): void {
    if (this.translated) return;

    this.countryService.getCountry().subscribe({
      next: (response) => {
        const raw = response as any;
        const countryCode = (
          raw?.countryCode ??
          raw?.country_code ??
          raw?.country ??
          ''
        ).toUpperCase();

        const lang = COUNTRY_LANG_MAP[countryCode];

        // Si el idioma es español o no se reconoce el país, no traducir
        if (!lang || lang === 'es') return;

        this.translateTo(lang);
      },
      error: () => {
        // Si falla la IP, no traducir — la página queda en español
      },
    });
  }

  /**
   * Traduce la página al idioma indicado usando el widget invisible de Google Translate.
   * Puedes llamar esto también manualmente si quieres un selector de idioma.
   */
  translateTo(langCode: string): void {
    this.translated = true;
    if (typeof (window as any).translatePageTo === 'function') {
      (window as any).translatePageTo(langCode);
    }
  }
}